import { APP_CONFIG } from '../../config';
import { get } from '../request';
import type { Membership } from '../../@types/membership';
import { membershipToApp } from './converter/membership';
import { ApiEndpoints } from '../apiEndpoints.constant';

export const getMembership = async (): Promise<Membership> =>
  membershipToApp(await get(`${APP_CONFIG.apiEndpoint}${ApiEndpoints.memberships}`));
